module.exports = __webpack_public_path__ + "static/media/IO.130668f7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/IO.svg
// module id = 2174
// module chunks = 7